import axios from 'axios';
import config from '../config';
import { handlingSession, sessionID } from './../../utils/handlingSession'
import { userLogs } from './../logs/userLogs'

export const getFrequencyDuration = async (retailerId, loanAmount, term) => {
    try {
        let url = `${config.hummBackendAppURL}application/show-frequency?loanAmount=${loanAmount}&term=${term}`;
        
        if(retailerId) {
            url = url + `&retailerId=${retailerId}`
        }
        const response = await axios.get(url, { headers: sessionID('secured') });

        return response;
    } catch (error) {
        let url = `${config.hummBackendAppURL}application/show-frequency?loanAmount=${loanAmount}&term=${term}`;
        if(retailerId) {
            url = url + `&retailerId=${retailerId}`
        }
        await userLogs(url, { retailerId, loanAmount, term }, error);
        if (error.response) {
            handlingSession(error.response.status);
            return error.response;
        }

        throw error;
    }
};
